/* ==========================================================================
   YİGİTFY KAPIDA ÖDEME — modal + sipariş POST (TR-UYARLAMA-SPEC §5)
   Bağımlılık yok. theme.liquid her sayfada yükler; modal ([data-ycod])
   yalnız ürün şablonlarında bulunduğundan diğer sayfalarda sessizce çıkar.

   Sözleşme:
   - POST {endpoint}/api/kapida/{store_id}/siparis  (X-Yigitfy-Form-Key başlığı)
   - POST {endpoint}/api/kapida/{store_id}/kod      (indirim kodu ön izlemesi,
     10 Eyl 2026: aynı başlık; kod + aynı kalemler → {kod, aciklama,
     indirim_kurus, toplam_kurus}. Sipariş gövdesine indirim_kodu eklenir,
     panel sipariş anında yeniden doğrular; kod_hatasi:true dönerse kod
     düşürülür ve mesaj kod alanının altında gösterilir)
   - GET  {endpoint}/api/kapida/adresler?v=N        (il/ilçe listesi; ETag'li,
     1s tarayıcı önbelleği. N = ADRES_SURUM, veri düzeltilince artırılır)
   - sessionStorage "yigitfy_kaynak"  → utm parametreleri + fbclid (theme.js yazar, burada okunur)
   - sessionStorage "yigitfy_iller_v<N>" → {t: epoch_ms, data: [...]} (oturum
     bitince ölür — panel verisi güncellenince kimse bayat liste görmez)
   - FİYAT GÖNDERİLMEZ: panel aynı yüzdelerle hesaplar, tema yalnız gösterir.
   - SEPET MODU (2 Eyl 2026): data-cod-open="cart" ile açılınca satırlar
     GET {cart_url}.js'ten okunur, toplam Shopify sepetinin kendi tutarıdır;
     başarıda POST {cart_url}/clear.js ile sepet boşaltılır (çift sipariş
     olmasın). Panel kalemleri ürün başına kademeyle yeniden fiyatlar.
   ========================================================================== */
(function () {
  'use strict';

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  // Adres listesi sürümü. Panel verisi düzeltildiğinde BURAYI ARTIR: hem
  // sessionStorage anahtarı hem de istek URL'si değişir, böylece müşterinin
  // tarayıcısında duran BAYAT kopya (HTTP önbelleği) atlanır. 25 Ağu'da il
  // listesi Türkçe alfabetik sıraya çekildi ama v4 URL'si önbellekten
  // döndüğü için ÇANKIRI/İSTANBUL/İZMİR müşteride hâlâ en altta görünüyordu.
  var ADRES_SURUM = '5';
  var CITY_CACHE_KEY = 'yigitfy_iller_v' + ADRES_SURUM;
  var CITY_CACHE_MS = 30 * 60 * 1000; // 30 dk — veri düzeltmeleri hızlı yayılsın
  var MIN_SUBMIT_MS = 3000;
  // Panel sınırları (app/kapida.py MAX_KALEM / MAX_ADET / ACIK_ADRES_MAX ile birebir)
  var MAX_KALEM = 30;
  var MAX_ADET = 10;
  var ADRES_MIN = 5;
  var ADRES_MAX = 300;
  var ADRES_SAYAC_ESIK = 240;   // sayaç bu uzunluktan sonra görünür
  // Panel kontratıyla birebir: mahalle listede yoksa (köy) bu değer gönderilir
  // ve köy/mahalle adı mahalle_diger alanında taşınır.
  var MAHALLE_DIGER = '__diger__';
  var MAHALLE_DIGER_LABEL = 'Köyde oturuyorum / mahallem listede yok';

  var M = null; // aktif modal örneği (theme editor bölümü yeniden yüklerse tazelenir)

  /* ---------------------------------------------------- Clarity olayları
     Müşterinin form içindeki YOLCULUĞU izlenir (hangi alanda takıldı, nerede
     vazgeçti). Girilen DEĞERLER asla gönderilmez — yalnız olay adı ve etiket.
     clarity yüklü değilse (ID tanımsız/engellenmiş) sessizce çıkar. */
  function cOlay(ad) {
    try { if (window.clarity) window.clarity('event', ad); } catch (e) {}
  }
  function cEtiket(anahtar, deger) {
    try { if (window.clarity) window.clarity('set', anahtar, String(deger)); } catch (e) {}
  }
  var _gorulenAlanlar = {};
  function cAlanOlayi(alan) {
    if (_gorulenAlanlar[alan]) return;   // alan başına tek olay (gürültü olmasın)
    _gorulenAlanlar[alan] = true;
    cOlay('kapida_alan_' + alan);
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    // Eski tarayıcı yedeği (v4 benzeri)
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function money(cents) {
    var T = window.ArkhelaisTheme;
    if (T && typeof T.formatMoney === 'function') return T.formatMoney(cents);
    var n = (cents / 100).toFixed(2).replace('.', ',');
    return n.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' TL';
  }

  function digitsOnly(v) {
    return String(v || '').replace(/\D+/g, '');
  }

  /** 05XX... biçimine getirir; geçersizse null döner. Kapıda ödeme kurye
      araması + SMS takibi cep ister: yalnız 5XX kabul edilir (sabit hat yok). */
  function normalizePhone(v) {
    // 21 Eyl 2026: odakta eklenen "0"ın arkasına yapıştırılan "0532…" / "+90 532…"
    // ("00532…", "0+90532…") ve "0090…" biçimleri de kabul edilir; müşteri
    // fazladan 0/+90 yüzünden "geçersiz numara" duvarına çarpmıyor.
    var d = digitsOnly(v).replace(/^0+/, '0');          // 00532… → 0532…, 0090… → 090…
    var m = d.match(/^0?(?:90)?(5\d{9})$/);            // 5…, 05…, 905…, 0905…
    return m ? '0' + m[1] : null;
  }

  /** fetch + zaman aşımı (21 Eyl 2026): asılı kalan istek select'i "Yükleniyor…"da,
      kod alanını salt-okunurda bırakıyordu. AbortController yoksa düz fetch. */
  function fetchZamanAsimli(url, opts, ms) {
    var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
    var o = opts || {};
    if (ctrl) o.signal = ctrl.signal;
    var zamanlayici = ctrl ? setTimeout(function () { ctrl.abort(); }, ms || 10000) : null;
    return fetch(url, o).then(function (r) {
      if (zamanlayici) clearTimeout(zamanlayici);
      return r;
    }, function (err) {
      if (zamanlayici) clearTimeout(zamanlayici);
      throw err;
    });
  }

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* ------------------------------------------------------- modal kurulumu */

  function initModal() {
    var root = $('[data-ycod]');
    if (!root) {
      M = null;
      return;
    }
    if (M && M.root === root) return;

    var tiers = [];
    try {
      tiers = JSON.parse(($('[data-ycod-tiers]', root) || {}).textContent) || [];
    } catch (e) {
      tiers = [];
    }
    if (!tiers.length) tiers = [{ qty: 1, pct: 0, code: '', label: 'Tek Paket' }];

    M = {
      root: root,
      panel: $('.ycod__panel', root),
      form: $('[data-ycod-form]', root),
      success: $('[data-ycod-success]', root),
      alert: $('[data-ycod-alert]', root),
      wa: $('[data-ycod-wa]', root),
      submitBtn: $('[data-ycod-submit]', root),
      submitLabel: $('[data-ycod-submit-label]', root),
      totalEl: $('[data-ycod-total]', root),
      radios: $$('[data-ycod-tier]', root),
      bumpBox: $('[data-ycod-bump="a"]', root),
      bumpKutu: $('[data-ycod-bump-kutu="a"]', root),
      // İkinci PDP ek ürünü (yuva b, 10 Eyl 2026): yuva a ile aynı fırsat
      // modeli (katalog + paket_fiyat metafield'ı, 2+ pakette katalog); panel
      // bayraksız, metafield'dan fiyatlar. Yalnız bump_b_enabled şablonlarda.
      bumpBoxB: $('[data-ycod-bump="b"]', root),
      bumpKutuB: $('[data-ycod-bump-kutu="b"]', root),
      // KÖ fırsat kartları (Bıdık, eldiven…): kutu + kart + varyant + kuruş.
      // Fiyat kartın data-fiyat'ından (kaynağı ürünün cod_firsat_fiyat
      // metafield'ı); panel aynı metafield'dan biçer, yüzde uygulanmaz.
      firsatlar: $$('[data-ycod-firsat]', root).map(function (box) {
        return {
          box: box,
          kart: box.closest('[data-ycod-firsat-kart]'),
          variant: parseInt(box.getAttribute('data-ycod-firsat'), 10) || 0,
          price: parseInt(box.getAttribute('data-fiyat'), 10) || 0,
          dokunuldu: false
        };
      }),
      // Eldiven popup'ı (kök div'in dışında, yalnız ürün sayfasında)
      pop: $('[data-ycod-pop]'),
      popAcik: false,
      urunBox: $('[data-ycod-urun-modu]', root),
      sepetBox: $('[data-ycod-sepet-modu]', root),
      linesEl: $('[data-ycod-lines]', root),
      sepetBosEl: $('[data-ycod-sepet-bos]', root),
      hp: $('[data-ycod-hp]', root),
      captchaEl: $('[data-ycod-captcha]', root),
      // İndirim kodu (10 Eyl 2026): "İndirim kodum var" satırı + açılır alan.
      // Tutar PANELDEN gelir (kodUygula); burada yalnız gösterim ve durum.
      kodToggle: $('[data-ycod-kod-toggle]', root),
      kodToggleText: $('[data-ycod-kod-toggle-text]', root),
      kodPanel: $('[data-ycod-kod-panel]', root),
      kodRow: $('[data-ycod-kod-row]', root),
      kodInput: $('[data-ycod-kod-input]', root),
      kodBtn: $('[data-ycod-kod-uygula]', root),
      kodOk: $('[data-ycod-kod-ok]', root),
      kodOkAd: $('[data-ycod-kod-ad]', root),
      kodOkAciklama: $('[data-ycod-kod-aciklama]', root),
      kodKaldirBtn: $('[data-ycod-kod-kaldir]', root),
      kodSatir: $('[data-ycod-kod-satir]', root),
      kodSatirAd: $('[data-ycod-kod-satir-ad]', root),
      kodSatirTutar: $('[data-ycod-kod-satir-tutar]', root),
      kod: null,          // {kod, indirim (kuruş), aciklama, imza} — uygulanmış kod
      kodAcik: false,
      kodIstek: 0,        // yarış: yalnız en son isteğin yanıtı işlenir
      kodZamanlayici: null,
      cfg: {
        endpoint: (root.getAttribute('data-endpoint') || '').replace(/\/+$/, ''),
        storeId: root.getAttribute('data-store-id') || '1',
        formKey: root.getAttribute('data-form-key') || '',
        sitekey: root.getAttribute('data-turnstile') || '',
        metaPixel: root.getAttribute('data-meta-pixel') || '',
        tiktokPixel: root.getAttribute('data-tiktok-pixel') || '',
        // Sipariş alındı sayfası (3 Eyl 2026): doluysa başarıda buraya
        // yönlendirilir; boşsa modal içi onay ekranı (yedek yol) kullanılır.
        successUrl: (root.getAttribute('data-success-url') || '').trim(),
        variantId: parseInt(root.getAttribute('data-variant-id'), 10) || 0,
        unitPrice: parseInt(root.getAttribute('data-unit-price'), 10) || 0,
        bumpEnabled: root.getAttribute('data-bump-enabled') === '1',
        bumpVariant: parseInt(root.getAttribute('data-bump-variant'), 10) || 0,
        bumpPrice: parseInt(root.getAttribute('data-bump-price'), 10) || 0,
        bumpFirsat: parseInt(root.getAttribute('data-bump-firsat'), 10) || 0,
        bumpKatalog: parseInt(root.getAttribute('data-bump-katalog'), 10) || 0,
        bumpCompareAt: parseInt(root.getAttribute('data-bump-compare-at'), 10) || 0,
        bumpBEnabled: root.getAttribute('data-bump-b-enabled') === '1',
        bumpBVariant: parseInt(root.getAttribute('data-bump-b-variant'), 10) || 0,
        bumpBPrice: parseInt(root.getAttribute('data-bump-b-price'), 10) || 0,
        bumpBFirsat: parseInt(root.getAttribute('data-bump-b-firsat'), 10) || 0,
        bumpBKatalog: parseInt(root.getAttribute('data-bump-b-katalog'), 10) || 0,
        bumpBCompareAt: parseInt(root.getAttribute('data-bump-b-compare-at'), 10) || 0,
        // Kademe hediyesi (23 Eyl 2026): boş varyant = hediye kapalı
        hediyeVariant: parseInt(root.getAttribute('data-hediye-variant'), 10) || 0,
        hediyeEsik: parseInt(root.getAttribute('data-hediye-esik'), 10) || 0
      },
      hediyeSatir: $('[data-ycod-hediye-satir]', root),
      tiers: tiers,
      tierIdx: 0,
      // Sepet modu (2 Eyl): çekmece/sepet sayfasından açılınca satırlar
      // /cart.js'ten gelir, toplam Shopify sepetinin kendi tutarıdır.
      // cartOnly = theme.liquid'in ürün olmayan sayfalara bastığı örnek.
      cartOnly: root.getAttribute('data-mode') === 'cart',
      mode: root.getAttribute('data-mode') === 'cart' ? 'cart' : 'product',
      cart: null,
      cartTotal: 0,
      open: false,
      openedAt: 0,
      idKey: null,
      eventId: null,
      captchaToken: '',
      captchaWidget: null,
      captchaLoaded: false,
      citiesLoaded: false,
      manualAddress: false,
      submitting: false,
      succeeded: false,
      // Başarıdan sonra sayfa değişene kadar açık kalır: bu sırada kapatma
      // (Esc / overlay / X) yok sayılır, yoksa closeModal'ın sepet sayfası
      // reload'u yönlendirmeyle yarışıp onay sayfasını ve pikseli düşürüyordu.
      yonlendiriliyor: false,
      lastFocus: null
    };

    // Varsayılan kademe: işaretli radio (yoksa 0)
    M.radios.forEach(function (r, i) {
      if (r.checked) M.tierIdx = i;
      r.addEventListener('change', function () {
        selectTier(i, true);
      });
    });

    if (M.bumpBox) {
      M.bumpBox.addEventListener('change', function () {
        updateTotals();
        cOlay(M.bumpBox.checked ? 'kapida_upsell_eklendi' : 'kapida_upsell_kaldirildi');
      });
    }
    if (M.bumpBoxB) {
      M.bumpBoxB.addEventListener('change', function () {
        updateTotals();
        cOlay(M.bumpBoxB.checked ? 'kapida_upsell_b_eklendi' : 'kapida_upsell_b_kaldirildi');
      });
    }

    M.firsatlar.forEach(function (f) {
      f.box.addEventListener('change', function () {
        f.dokunuldu = true;
        updateTotals();
        cOlay(f.box.checked ? 'kapida_upsell2_eklendi' : 'kapida_upsell2_kaldirildi');
      });
      // Seçenek çipleri (24 Eyl 2026, Uzak Atış Kaşığı gramları): çip seçimi
      // niyet sayılır → kutu işaretlenir; kartın varyantı/fiyatı güncellenir.
      if (!f.kart) return;
      $$('[data-ycod-firsat-secenek]', f.kart).forEach(function (r) {
        r.addEventListener('change', function () {
          if (!r.checked) return;
          firsatSecenekUygula(f, r);
          f.box.checked = true;
          f.dokunuldu = true;
          updateTotals();
          cOlay('kapida_upsell2_secenek');
        });
      });
    });

    // İndirim kodu: aç/kapat, Uygula (tık + Enter), Kaldır
    if (M.kodToggle) {
      M.kodToggle.addEventListener('click', function () {
        kodAcKapat();
        cOlay(M.kodAcik ? 'kapida_kod_acildi' : 'kapida_kod_kapandi');
        // Açılınca imleç alana gelir (kullanıcı hareketi içinde → mobil klavye açılır)
        if (M.kodAcik && !M.kod && M.kodInput) M.kodInput.focus({ preventScroll: true });
      });
    }
    if (M.kodBtn) {
      M.kodBtn.addEventListener('click', function () {
        kodUygula(M.kodInput ? M.kodInput.value : '', false);
      });
    }
    if (M.kodInput) {
      // Enter formu göndermesin, kodu uygulasın
      M.kodInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          kodUygula(M.kodInput.value, false);
        }
      });
      M.kodInput.addEventListener('input', function () {
        setFieldError('indirim_kodu', '');
      });
    }
    if (M.kodKaldirBtn) M.kodKaldirBtn.addEventListener('click', kodKaldir);

    // Alan bazlı yolculuk: hangi alana kadar geldi, nerede bıraktı
    ['ad_soyad', 'telefon', 'il', 'ilce', 'mahalle', 'acik_adres', 'eposta'].forEach(function (alan) {
      var el = $('[data-ycod-field="' + alan + '"]', root);
      if (!el) return;
      el.addEventListener('change', function () { cAlanOlayi(alan); });
      el.addEventListener('blur', function () {
        if (el.value) cAlanOlayi(alan);
      }, true);
    });

    // PDP'deki upsell kutusu (bundle altı) modaldakiyle senkron çalışır
    M.pdpBump = document.querySelector('[data-pdp-bump="a"]');
    if (M.pdpBump && M.bumpBox) {
      M.pdpBump.addEventListener('change', function () {
        M.bumpBox.checked = M.pdpBump.checked;
        updateTotals();
      });
      M.bumpBox.addEventListener('change', function () {
        M.pdpBump.checked = M.bumpBox.checked;
        // theme.js'in PDP toplamları da tazelensin (programatik set event üretmez)
        M.pdpBump.dispatchEvent(new Event('change'));
      });
    }
    // İkinci kutu (b) aynı şekilde senkron
    M.pdpBumpB = document.querySelector('[data-pdp-bump="b"]');
    if (M.pdpBumpB && M.bumpBoxB) {
      M.pdpBumpB.addEventListener('change', function () {
        M.bumpBoxB.checked = M.pdpBumpB.checked;
        updateTotals();
      });
      M.bumpBoxB.addEventListener('change', function () {
        M.pdpBumpB.checked = M.bumpBoxB.checked;
        M.pdpBumpB.dispatchEvent(new Event('change'));
      });
    }

    if (M.form) {
      M.form.addEventListener('submit', onSubmit);
    }

    bindPhoneInput();
    bindAddressCounter();
    bindCitySelect();
    updateTotals();
  }

  /* ------------------------------------------------------- kademe/toplam */

  function tierSubtotal(i) {
    var t = M.tiers[i] || M.tiers[0];
    return M.cfg.unitPrice * (t.qty || 1);
  }

  /** KAPIDA ÖDEME toplamı — panel formülüyle BİREBİR:
      birim×(1−%) kuruşa yuvarlanır, adetle çarpılır. */
  function tierTotal(i) {
    var t = M.tiers[i] || M.tiers[0];
    var qty = t.qty || 1;
    // Kart yolu / Shopify Basic % ile AYNI (25 Ağu): birim indirimi AŞAĞI
    // yuvarlanır. Eski Math.round() PDP kartlarıyla 2-3 kuruş ayrışıyordu.
    var ind = Math.floor((M.cfg.unitPrice * (t.pct || 0)) / 100);
    return (M.cfg.unitPrice - ind) * qty;
  }

  function bumpChecked() {
    return !!(M.cfg.bumpEnabled && M.cfg.bumpVariant && M.bumpBox && M.bumpBox.checked);
  }

  /** İşaretli ve görünür KÖ fırsat kartları (sepet modunda sepette olanlar gizlidir). */
  function firsatSecili() {
    return M.firsatlar.filter(function (f) {
      return f.variant && f.price && f.box.checked && !(f.kart && f.kart.hidden);
    });
  }

  function firsatToplam() {
    return firsatSecili().reduce(function (t, f) { return t + f.price; }, 0);
  }

  function firsatBul(variant) {
    return M.firsatlar.filter(function (f) { return String(f.variant) === String(variant); })[0] || null;
  }

  /** Seçenekli fırsat kartında (24 Eyl 2026) seçilen çipin varyantını ve
      fiyatını hem M.firsatlar kaydına hem kartın data-*'larına yazar (panel
      yükü firsatSecili()'den kurulur), görünen ad/görsel/fiyatları tazeler.
      Fiyat yalnız gösterim: panel varyantın cod_firsat_fiyat'ından biçer. */
  function firsatSecenekUygula(f, r) {
    var vid = parseInt(r.value, 10) || 0;
    var fiyat = parseInt(r.getAttribute('data-fiyat'), 10) || 0;
    var katalog = parseInt(r.getAttribute('data-katalog'), 10) || 0;
    if (!vid || !fiyat) return;
    f.variant = vid;
    f.price = fiyat;
    f.box.setAttribute('data-ycod-firsat', String(vid));
    f.box.setAttribute('data-fiyat', String(fiyat));
    f.kart.setAttribute('data-ycod-firsat-kart', String(vid));
    var ad = $('[data-ycod-firsat-ad]', f.kart);
    if (ad && r.getAttribute('data-ad')) ad.textContent = r.getAttribute('data-ad');
    var kat = $('[data-ycod-firsat-katalog]', f.kart);
    if (kat) kat.textContent = money(katalog);
    var yeni = $('[data-ycod-firsat-fiyat]', f.kart);
    if (yeni) yeni.textContent = money(fiyat);
    var kaz = $('[data-ycod-firsat-kazanc]', f.kart);
    if (kaz) kaz.textContent = money(Math.max(0, katalog - fiyat)) + ' kazanç';
    var img = $('.ycod__bump2-img', f.kart);
    var src = r.getAttribute('data-gorsel');
    if (img && src) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = src;
    }
  }

  /*
    Ek ürün fiyatı SEÇİLİ KADEMEYE bağlı (25 Ağu, canlı testle doğrulandı):
    fırsat fiyatını kart yolunda mağazanın BXGY indirimi verir ve Shopify
    "alınan" satır zaten ürün indirimi taşıyorsa BXGY'yi açmıyor. 2+ pakette
    ek ürün katalog fiyatından geçer; panel de aynı kuralı uygular
    (app/kapida.py). Kutuda gerçekte ödenecek tutar yazar.
  */
  function bumpFiyat() {
    var t = M.tiers[M.tierIdx] || M.tiers[0] || {};
    var qty = t.qty || 1;
    var f = qty <= 1 ? (M.cfg.bumpFirsat || M.cfg.bumpPrice) : (M.cfg.bumpKatalog || M.cfg.bumpPrice);
    return f || M.cfg.bumpPrice;
  }

  function bumpKutusunuTazele() {
    if (!M) return;
    kutuyuTazele('a', bumpFiyat(), M.cfg.bumpKatalog, M.cfg.bumpCompareAt);
    kutuyuTazele('b', bumpBFiyat(), M.cfg.bumpBKatalog, M.cfg.bumpBCompareAt);
  }

  /** Bir yuvanın (a|b) fiyat/üstü çizili metnini günceller. */
  function kutuyuTazele(yuva, fiyat, katalogCfg, compareAtCfg) {
    var katalog = katalogCfg || fiyat;
    var carpi = fiyat < katalog ? katalog : (compareAtCfg || 0);
    var el = $('[data-ycod-bump-price="' + yuva + '"]', M.root);
    if (el) el.textContent = money(fiyat);
    var s = $('[data-ycod-bump-compare="' + yuva + '"]', M.root);
    var y = $('[data-ycod-bump-yerine="' + yuva + '"]', M.root);
    if (s) {
      s.textContent = money(carpi);
      s.hidden = carpi <= fiyat;
    }
    if (y) y.hidden = carpi <= fiyat;
  }

  /** İkinci ek ürün (b): işaretli mi, seçili kademeye göre fiyatı ne? */
  function bumpBChecked() {
    return !!(M.cfg.bumpBEnabled && M.cfg.bumpBVariant && M.bumpBoxB && M.bumpBoxB.checked);
  }

  function bumpBFiyat() {
    var t = M.tiers[M.tierIdx] || M.tiers[0] || {};
    var qty = t.qty || 1;
    var f = qty <= 1 ? (M.cfg.bumpBFirsat || M.cfg.bumpBPrice) : (M.cfg.bumpBKatalog || M.cfg.bumpBPrice);
    return f || M.cfg.bumpBPrice;
  }

  function grandTotal() {
    var toplam;
    if (M.mode === 'cart') {
      // Shopify sepetinin tutarı (otomatik indirimler dahil) + fırsat kartları
      toplam = (M.cartTotal || 0) + firsatToplam();
    } else {
      toplam = tierTotal(M.tierIdx)
        + (bumpChecked() ? bumpFiyat() : 0)
        + (bumpBChecked() ? bumpBFiyat() : 0)
        + firsatToplam();
    }
    // Uygulanmış indirim kodu (tutar panelden geldi; satırlar değişince
    // kodTazele yeniden doğrular)
    if (M.kod && M.kod.indirim > 0) toplam = Math.max(0, toplam - M.kod.indirim);
    return toplam;
  }

  /** Panele giden "ekranda gösterilen toplam" (kuruş, tam sayı; bilinmiyorsa 0).
      Sepet modunda /cart.js gelmediyse 0 → panel karşılaştırma yapmaz. */
  function gosterilenToplam() {
    if (!M) return 0;
    if (M.mode === 'cart' && !M.cart) return 0;
    var t = Math.round(grandTotal());
    return (isFinite(t) && t > 0) ? t : 0;
  }

  /** Kademe hediyesi hakkı (23 Eyl 2026) — panel (app/kapida.py fiyatlandir)
      aynı kuralla siparişe 0 TL ekler: AYNI üründen eşik kadar adet. Ürün
      modunda seçili kademenin adedi, sepet modunda sepetteki ürün adetleri
      (hediye satırının kendisi loadCart'ta zaten atlanır). */
  function hediyeHakki() {
    var esik = M.cfg.hediyeEsik;
    if (!M.cfg.hediyeVariant || !(esik > 0)) return false;
    if (M.mode === 'cart') {
      var adet = {};
      (M.cart || []).forEach(function (l) {
        var k = l.product_id || l.variant_id;
        adet[k] = (adet[k] || 0) + l.qty;
      });
      return Object.keys(adet).some(function (k) { return adet[k] >= esik; });
    }
    var t = M.tiers[M.tierIdx] || M.tiers[0] || {};
    return (t.qty || 1) >= esik;
  }

  function updateTotals() {
    if (!M) return;
    bumpKutusunuTazele();
    var bekliyor = M.mode === 'cart' && !M.cart;   // /cart.js henüz gelmedi
    goster(M.hediyeSatir, !bekliyor && hediyeHakki());
    var total = bekliyor ? '…' : money(grandTotal());
    if (M.totalEl) M.totalEl.textContent = total;
    if (M.submitLabel) M.submitLabel.textContent = 'SİPARİŞİ TAMAMLA — ' + total;
    kodTazele();
  }

  function selectTier(i, fromModal) {
    if (!M || !M.tiers[i]) return;
    M.tierIdx = i;
    if (fromModal) {
      cOlay('kapida_kademe_' + ((M.tiers[i] || {}).qty || 1));
      cEtiket('kademe', (M.tiers[i] || {}).label || '');
    }
    M.radios.forEach(function (r, n) {
      r.checked = n === i;
      var row = r.closest('.ycod__tier');
      if (row) row.classList.toggle('is-selected', n === i);
    });
    updateTotals();
    if (fromModal) syncToPdp(i);
  }

  /** PDP kartındaki radio'yu tetikler — theme.js fiyatları/sticky'yi günceller. */
  function syncToPdp(i) {
    var bundles = $$('[data-bundle-form] [data-bundle]');
    if (!bundles[i]) return;
    var radio = $('input[type="radio"]', bundles[i]);
    if (radio && !radio.checked) radio.click();
  }

  /** Modal açılırken PDP'de seçili kademeyi devralır. */
  function syncFromPdp() {
    var bundles = $$('[data-bundle-form] [data-bundle]');
    if (!bundles.length) return;
    var idx = -1;
    bundles.forEach(function (b, n) {
      var radio = $('input[type="radio"]', b);
      if (radio && radio.checked) idx = n;
    });
    if (idx > -1 && M.tiers[idx]) selectTier(idx, false);
  }

  /* ------------------------------------------------------------ sepet modu
     Çekmece/sepet sayfasındaki "KAPIDA ÖDEMEYLE SİPARİŞ" (data-cod-open="cart")
     modalı sepet moduna alır: kademe kartları yerine sepet satırları, toplam
     Shopify sepetinin KENDİ tutarı (otomatik indirimler dahil — kart yoluyla
     birebir). Panel kalemleri ürün başına kademe kuralıyla yeniden fiyatlar
     (app/kapida.py). Ürün sayfasındaki modal iki modu da taşır; diğer
     sayfalarda theme.liquid yalnız sepet modlu bir modal basar. */

  function cartUrl() {
    var T = window.ArkhelaisTheme || {};
    return (M && M.root.getAttribute('data-cart-url')) || (T.routes && T.routes.cart_url) || '/cart';
  }

  function onCartPage() {
    var u = cartUrl().replace(/\/+$/, '');
    return window.location.pathname.replace(/\/+$/, '') === u;
  }

  /** /cart.js → aynı varyantın satırları birleşir (BXGY bölmesi), hediye ve
      0 TL satırlar atlanır. */
  function loadCart() {
    return fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        var map = {};
        var order = [];
        (cart.items || []).forEach(function (it) {
          if (!it || !it.variant_id) return;
          if ((it.properties && it.properties._hediye) || !(it.final_line_price > 0)) return;
          var key = String(it.variant_id);
          if (!map[key]) {
            map[key] = {
              variant_id: key,
              product_id: it.product_id ? String(it.product_id) : '',
              title: it.product_title || it.title || '',
              variant_title: it.variant_title || '',
              image: it.image || '',
              qty: 0,
              final: 0,
              original: 0
            };
            order.push(key);
          }
          map[key].qty += it.quantity || 0;
          map[key].final += it.final_line_price || 0;
          map[key].original += it.original_line_price || 0;
        });
        M.cart = order.map(function (k) { return map[k]; });
        M.cartTotal = M.cart.reduce(function (t, l) { return t + l.final; }, 0);
        return M.cart;
      });
  }

  function imgUrl(u) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function goster(node, acik) {
    if (!node) return;
    node.hidden = !acik;
    node.style.display = acik ? '' : 'none';
  }

  function renderCartLines() {
    if (!M.linesEl) return;
    M.linesEl.innerHTML = '';
    var lines = M.cart || [];
    goster(M.sepetBosEl, !!(M.cart && !lines.length));
    lines.forEach(function (l) {
      var li = el('li', 'ycod__line');
      if (l.image) {
        var img = el('img', 'ycod__line-img');
        img.src = imgUrl(l.image);
        img.alt = '';
        img.width = 56;
        img.height = 56;
        img.loading = 'lazy';
        li.appendChild(img);
      } else {
        li.appendChild(el('span', 'ycod__line-img'));
      }
      var info = el('div', 'ycod__line-info');
      info.appendChild(el('span', 'ycod__line-title', l.title));
      var vt = l.variant_title && !/default/i.test(l.variant_title) ? l.variant_title + ' · ' : '';
      info.appendChild(el('span', 'ycod__line-qty', vt + l.qty + ' adet'));
      li.appendChild(info);
      var price = el('span', 'ycod__line-price');
      if (l.original > l.final) price.appendChild(el('s', '', money(l.original)));
      price.appendChild(el('strong', '', money(l.final)));
      li.appendChild(price);
      M.linesEl.appendChild(li);
    });
  }

  function cartHasVariant(vid) {
    if (!vid) return false;
    return (M.cart || []).some(function (l) { return String(l.variant_id) === String(vid); });
  }

  /** Moda göre blokları aç/kapat (ürün: kademeler + bump; sepet: satırlar). */
  function applyMode() {
    if (!M) return;
    var cartMode = M.mode === 'cart';
    goster(M.urunBox, !cartMode);
    goster(M.sepetBox, cartMode);
    goster(M.bumpKutu, !cartMode);
    if (cartMode && M.bumpBox) M.bumpBox.checked = false;
    goster(M.bumpKutuB, !cartMode);
    if (cartMode && M.bumpBoxB) M.bumpBoxB.checked = false;
    M.firsatlar.forEach(function (f) {
      // Ürün zaten sepetteyse "özel fırsat" kartı çıkmaz (panel de fırsatı
      // ancak sepette fırsat dışı başka kalem varken kabul eder). Seçenekli
      // kartta (24 Eyl) gruptaki herhangi bir ürün sepetteyse de çıkmaz.
      var grup = f.kart ? String(f.kart.getAttribute('data-ycod-firsat-grup-vids') || '').split(',') : [];
      var gizle = cartMode && (cartHasVariant(f.variant) ||
        grup.some(function (v) { return v && cartHasVariant(v); }));
      goster(f.kart, !gizle);
      if (gizle) f.box.checked = false;
    });
  }

  /** Sepet modunda sipariş alındıktan sonra Shopify sepeti boşaltılır ki aynı
      ürünler ikinci kez (kart yoluyla) sipariş edilmesin; çekmece tazelenir. */
  function sepetiBosalt() {
    M.cart = [];
    M.cartTotal = 0;
    // keepalive: yönlendirme isteği yarıda kesmesin (sepet dolu kalırsa müşteri
    // aynı ürünleri kart yoluyla ikinci kez sipariş edebiliyordu).
    return fetch(cartUrl() + '/clear.js',
                 { method: 'POST', headers: { Accept: 'application/json' }, keepalive: true })
      .then(function () {
        var T = window.ArkhelaisTheme || {};
        if (T.CartDrawer && typeof T.CartDrawer.refresh === 'function') return T.CartDrawer.refresh();
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------- eldiven popup'ı
     Ürün sayfasında KÖ butonuna basılınca (ürün modu) form açılmadan önce tek
     soruluk ara ekran: "… de ister misin?" Evet → formdaki fırsat kartı
     işaretli açılır; hayır/kapat/Esc → form yine açılır. Sayfa başına bir kez
     sorulur (bellekte; 2 Eyl kullanıcı kararı: sayfadan çıkıp girince yeniden
     sorulsun, sessionStorage kaldırıldı); yanıt aynı sayfadaki sonraki
     açılışlarda kartı belirler. */

  var popBellek = {};

  function popKarti() {
    if (!M || !M.pop) return null;
    var f = firsatBul(M.pop.getAttribute('data-ycod-pop-for'));
    return f && f.kart && !f.kart.hidden ? f : null;
  }

  function popAnahtar(f) {
    return 'yigitfy_pop_' + f.variant;
  }

  function popYaniti(f) {
    return popBellek[popAnahtar(f)] || '';
  }

  function popYanitla(f, yanit) {
    popBellek[popAnahtar(f)] = yanit;
  }

  function popGerekli() {
    var f = popKarti();
    return !!(f && !popYaniti(f));
  }

  /** Popup görseli lazy: gizli katmanda hiç inmez, açılınca boş kare görünürdü.
      İlk etkileşimde (dokunma/tıklama/tuş) ve en geç popup açılırken eager'a
      çevrilir — sayfayı yalnız okuyan ziyaretçiye ek indirme yok. */
  function popGorselOnyukle() {
    if (!M || !M.pop || M.popGorselHazir) return;
    M.popGorselHazir = true;
    $$('img[loading="lazy"]', M.pop).forEach(function (img) { img.loading = 'eager'; });
  }

  function popAc() {
    var f = popKarti();
    if (!f) return false;
    popGorselOnyukle();
    M.popAcik = true;
    M.pop.hidden = false;
    requestAnimationFrame(function () { M.pop.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    cOlay('kapida_pop_gosterildi');
    var evet = $('[data-ycod-pop-evet]', M.pop);
    if (evet) evet.focus();
    return true;
  }

  function popKapat(yanit) {
    if (!M || !M.pop) return;
    var f = popKarti();
    M.popAcik = false;
    M.pop.classList.remove('is-open');
    M.pop.hidden = true;
    document.body.style.overflow = '';
    if (f) {
      popYanitla(f, yanit);
      f.box.checked = yanit === 'evet';
      f.dokunuldu = true;
      cOlay(yanit === 'evet' ? 'kapida_pop_evet' : 'kapida_pop_hayir');
    }
    openModal('product');
  }

  /* --------------------------------------------------------- aç / kapat */

  function openModal(mode) {
    initModal();
    if (!M || M.open) return;
    if (!M.idKey) {
      M.idKey = uuid();
      M.eventId = uuid();
    }
    M.mode = (mode === 'cart' || M.cartOnly) ? 'cart' : 'product';
    M.lastFocus = document.activeElement;
    if (!M.submitting) hideAlerts();   // uçuştaki gönderimin sonucu görünür kalsın
    if (M.mode === 'cart') {
      M.cart = null;
      renderCartLines();
      applyMode();
      updateTotals();
      loadCart()
        .then(function () {
          renderCartLines();
          applyMode();
          updateTotals();
          if (!M.cart.length) showAlert('Sepetin boş. Önce bir ürün ekle.');
        })
        .catch(function () {
          M.cart = [];
          renderCartLines();
          updateTotals();
          showAlert('Sepet okunamadı. Sayfayı yenileyip tekrar dene.');
        });
    } else {
      // PDP kutusuyla senkron: sepet modu bump kutusunu boşaltmış olabilir
      if (M.pdpBump && M.bumpBox) M.bumpBox.checked = M.pdpBump.checked;
      if (M.pdpBumpB && M.bumpBoxB) M.bumpBoxB.checked = M.pdpBumpB.checked;
      // Popup'a bu oturumda "evet" dendiyse kart işaretli gelir (elle
      // değiştirilmediyse)
      M.firsatlar.forEach(function (f) {
        if (!f.dokunuldu && popYaniti(f) === 'evet') f.box.checked = true;
      });
      syncFromPdp();
      applyMode();
      updateTotals();
    }
    M.root.hidden = false;
    requestAnimationFrame(function () {
      M.root.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    M.open = true;
    // İlk açılıştan ölçülür: formu doldurup kapatıp yeniden açan müşteri
    // 3 sn eşiğine yanlışlıkla takılmasın (bot koruması amaca uygun kalır).
    if (!M.openedAt) M.openedAt = Date.now();
    cOlay(M.mode === 'cart' ? 'kapida_form_acildi_sepet' : 'kapida_form_acildi');
    cEtiket('urun', M.mode === 'cart' ? 'sepet' : (M.root.getAttribute('data-product-title') || '').slice(0, 60));
    cEtiket('kademe', (M.tiers[M.tierIdx] || {}).label || '');
    var closeBtn = $('.ycod__close', M.root);
    if (closeBtn) closeBtn.focus();
    loadCities();
    loadTurnstile();
  }

  function closeModal() {
    if (!M || !M.open || M.yonlendiriliyor) return;
    if (M.submitting) {
      // Gönderim sürerken kapatmak isteyen müşteri: sonucu kaçırmasın.
      showAlert('Siparişin gönderiliyor, lütfen birkaç saniye bekle.');
      return;
    }
    cOlay(M.succeeded ? 'kapida_kapatildi_siparisli' : 'kapida_kapatildi_siparissiz');
    if (M.succeeded && M.mode === 'cart' && onCartPage()) {
      // Sepet sayfası boşaltılmış sepeti göstermeli
      window.location.reload();
      return;
    }
    M.root.classList.remove('is-open');
    M.open = false;
    document.body.style.overflow = '';
    setTimeout(function () {
      if (M && !M.open) M.root.hidden = true;
    }, 260);
    if (M.lastFocus && M.lastFocus.focus) M.lastFocus.focus();
    if (M.succeeded) resetAfterSuccess();
  }

  /** Başarıdan sonra form yeni sipariş için sıfırlanır; kimlikler tazelenir. */
  function resetAfterSuccess() {
    M.succeeded = false;
    M.yonlendiriliyor = false;
    doneSubmitting();   // gönderim kilidi açılır (yoksa ikinci sipariş sessizce yutulur)
    M.idKey = uuid();
    M.eventId = uuid();
    if (M.form) {
      M.form.reset();
      M.form.hidden = false;
    }
    if (!M.manualAddress) {          // ilçe/mahalle listeleri eski siparişten kalmasın
      fillDistricts('');
      resetMahalle();
    }
    if (M.success) M.success.hidden = true;
    // İndirim kodu yeni siparişe taşınmaz (müşteri başına bir kez olabilir)
    M.kodIstek++;
    clearTimeout(M.kodZamanlayici);
    kodYukleniyor(false);
    M.kod = null;
    kodGoster();
    kodAcKapat(false);
    setFieldError('indirim_kodu', '');
    selectTier(M.tierIdx, false);
    if (M.mode === 'cart') renderCartLines();   // sepet boşaltıldı
    hideAlerts();
    resetCaptcha();
    updateTotals();
  }

  /* ------------------------------------------------- il / ilçe yükleme */

  function bindCitySelect() {
    var ilSel = getControl('il', true);
    if (!ilSel || ilSel.tagName !== 'SELECT') return;
    ilSel.addEventListener('change', function () {
      fillDistricts(ilSel.value);
    });
    var ilceSel = getControl('ilce', true);
    if (ilceSel && ilceSel.tagName === 'SELECT') {
      ilceSel.addEventListener('change', function () {
        fillMahalle(ilSel.value, ilceSel.value);
      });
    }
    var mahSel = $('select[data-ycod-field="mahalle"]', M.root);
    if (mahSel) {
      mahSel.addEventListener('change', function () {
        toggleMahalleDiger(mahSel.value === MAHALLE_DIGER);
      });
    }
  }

  function toggleMahalleDiger(goster) {
    var kutu = $('[data-ycod-mahalle-diger]', M.root);
    if (kutu) kutu.hidden = !goster;
    if (goster) {
      var inp = getControl('mahalle_diger');
      if (inp && inp.focus) inp.focus();
    } else {
      setFieldError('mahalle_diger', '');
    }
  }

  /** İlçe değişince mahalle listesi panelden çekilir (ilçe başına küçük liste). */
  function resetMahalle(mesaj) {
    var mahSel = $('select[data-ycod-field="mahalle"]', M.root);
    if (!mahSel) return;
    mahSel.innerHTML = '';
    var opt0 = document.createElement('option');
    opt0.value = '';
    opt0.textContent = mesaj || 'Önce ilçe seç';
    mahSel.appendChild(opt0);
    mahSel.disabled = true;
    toggleMahalleDiger(false);
  }

  function fillMahalle(ilName, ilceName) {
    if (M.manualAddress) return;
    if (!ilName || !ilceName) {
      resetMahalle();
      return;
    }
    resetMahalle('Yükleniyor…');
    fetchZamanAsimli(
      M.cfg.endpoint +
        '/api/kapida/mahalleler?v=' + ADRES_SURUM +
        '&il=' +
        encodeURIComponent(ilName) +
        '&ilce=' +
        encodeURIComponent(ilceName),
      { headers: { Accept: 'application/json' } },
      8000
    )
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (raw) {
        var list = (raw && raw.mahalleler) || [];
        var mahSel = $('select[data-ycod-field="mahalle"]', M.root);
        if (!mahSel) return;
        mahSel.innerHTML = '';
        var opt0 = document.createElement('option');
        opt0.value = '';
        opt0.textContent = 'Mahalle seç';
        mahSel.appendChild(opt0);
        list.forEach(function (mah) {
          var opt = document.createElement('option');
          opt.value = mah;
          opt.textContent = mah;
          mahSel.appendChild(opt);
        });
        // Listenin sonunda sabit köy seçeneği — köyden gelen sipariş kaybolmasın
        var optD = document.createElement('option');
        optD.value = MAHALLE_DIGER;
        optD.textContent = MAHALLE_DIGER_LABEL;
        mahSel.appendChild(optD);
        mahSel.disabled = false;
      })
      .catch(function () {
        // Mahalle listesi gelmezse sipariş engellenmez: köy/serbest alanına düş
        var mahSel = $('select[data-ycod-field="mahalle"]', M.root);
        if (mahSel) {
          mahSel.innerHTML = '';
          var optD = document.createElement('option');
          optD.value = MAHALLE_DIGER;
          optD.textContent = MAHALLE_DIGER_LABEL;
          mahSel.appendChild(optD);
          mahSel.disabled = false;
          mahSel.value = MAHALLE_DIGER;
        }
        toggleMahalleDiger(true);
      });
  }

  function cityCacheRead() {
    try {
      var raw = sessionStorage.getItem(CITY_CACHE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.t || !obj.data) return null;
      if (Date.now() - obj.t > CITY_CACHE_MS) return null;
      return obj.data;
    } catch (e) {
      return null;
    }
  }

  function cityCacheWrite(data) {
    try {
      sessionStorage.setItem(CITY_CACHE_KEY, JSON.stringify({ t: Date.now(), data: data }));
    } catch (e) {}
  }

  /**
   * Beklenen kanonik yanıt: {"iller": [{"il": "Adana", "ilceler": ["Aladağ", ...]}, ...]}
   * Düz dizi veya {"Adana": [...]} sözlüğü de tolere edilir.
   */
  function normalizeCities(raw) {
    if (raw && raw.iller) raw = raw.iller;
    var out = [];
    if (Array.isArray(raw)) {
      raw.forEach(function (item) {
        if (typeof item === 'string') {
          out.push({ il: item, ilceler: [] });
        } else if (item && typeof item === 'object') {
          var name = item.il || item.ad || item.name || '';
          if (name) out.push({ il: String(name), ilceler: item.ilceler || item.districts || [] });
        }
      });
    } else if (raw && typeof raw === 'object') {
      Object.keys(raw).forEach(function (k) {
        out.push({ il: k, ilceler: Array.isArray(raw[k]) ? raw[k] : [] });
      });
    }
    return out;
  }

  function loadCities() {
    if (!M || M.citiesLoaded || M.manualAddress) return;
    var cached = cityCacheRead();
    if (cached && cached.length) {
      fillCities(cached);
      return;
    }
    if (!M.cfg.endpoint) {
      manualAddressMode();
      return;
    }
    fetchZamanAsimli(M.cfg.endpoint + '/api/kapida/adresler?v=' + ADRES_SURUM,
          { headers: { Accept: 'application/json' } }, 8000)
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (raw) {
        var list = normalizeCities(raw);
        if (!list.length) throw new Error('bos liste');
        cityCacheWrite(list);
        fillCities(list);
      })
      .catch(function () {
        // Liste gelmedi diye sipariş engellenmez — elle girişe düşülür.
        manualAddressMode();
      });
  }

  function fillCities(list) {
    M.cities = list;
    M.citiesLoaded = true;
    var ilSel = getControl('il', true);
    if (!ilSel || ilSel.tagName !== 'SELECT') return;
    var current = ilSel.value;
    ilSel.innerHTML = '';
    var opt0 = document.createElement('option');
    opt0.value = '';
    opt0.textContent = 'İl seç';
    ilSel.appendChild(opt0);
    list.forEach(function (item) {
      var opt = document.createElement('option');
      opt.value = item.il;
      opt.textContent = item.il;
      ilSel.appendChild(opt);
    });
    if (current) ilSel.value = current;
    fillDistricts(ilSel.value);
  }

  function fillDistricts(ilName) {
    var ilceSel = getControl('ilce', true);
    if (!ilceSel || ilceSel.tagName !== 'SELECT') return;
    ilceSel.innerHTML = '';
    var opt0 = document.createElement('option');
    opt0.value = '';
    if (!ilName) {
      opt0.textContent = 'Önce il seç';
      ilceSel.appendChild(opt0);
      ilceSel.disabled = true;
      return;
    }
    opt0.textContent = 'İlçe seç';
    ilceSel.appendChild(opt0);
    resetMahalle();
    var found = null;
    (M.cities || []).forEach(function (item) {
      if (item.il === ilName) found = item;
    });
    var districts = found ? found.ilceler || [] : [];
    districts.forEach(function (d) {
      var opt = document.createElement('option');
      opt.value = d;
      opt.textContent = d;
      ilceSel.appendChild(opt);
    });
    ilceSel.disabled = false;
  }

  /** Adres listesi alınamadıysa select'ler gizlenir, serbest metin açılır. */
  function manualAddressMode() {
    if (!M || M.manualAddress) return;
    M.manualAddress = true;
    M.root.classList.add('ycod--manual');
    // Müşteri neden liste yerine kutu gördüğünü bilsin (panel serbest metni
    // Türkçe büyük/küçük harf ve ASCII toleransıyla eşleştirir, 21 Eyl 2026).
    var not = $('[data-ycod-manual-not]', M.root);
    if (not) not.hidden = false;
    ['il', 'ilce', 'mahalle'].forEach(function (n) { setFieldError(n, ''); });
    ['il', 'ilce'].forEach(function (name) {
      var sel = $('select[data-ycod-field="' + name + '"]', M.root);
      var txt = $('input[data-ycod-fallback="' + name + '"]', M.root);
      if (sel) {
        sel.hidden = true;
        sel.disabled = true;
      }
      if (txt) txt.hidden = false;
    });
    // Mahalle select'i listesiz çalışamaz: köy/serbest alanı açılır
    var mahSel = $('select[data-ycod-field="mahalle"]', M.root);
    if (mahSel) {
      mahSel.hidden = true;
      mahSel.disabled = true;
      var kutu = mahSel.closest('.ycod__field');
      if (kutu) kutu.hidden = true;
    }
    toggleMahalleDiger(true);
  }

  /** Aktif kontrolü döndürür (select ya da manuel moddaki text input). */
  function getControl(name, preferSelect) {
    if (!M) return null;
    if (M.manualAddress && !preferSelect && (name === 'il' || name === 'ilce')) {
      return $('input[data-ycod-fallback="' + name + '"]', M.root);
    }
    var el = $('[data-ycod-field="' + name + '"]', M.root);
    if (el && el.hidden && (name === 'il' || name === 'ilce')) {
      return $('input[data-ycod-fallback="' + name + '"]', M.root);
    }
    return el;
  }

  /* ------------------------------------------------------ telefon girişi */

  function bindPhoneInput() {
    var tel = getControl('telefon');
    if (!tel) return;
    tel.addEventListener('focus', function () {
      if (!tel.value) tel.value = '0';
    });
    tel.addEventListener('input', function () {
      // 5 ile başlayan girişte otomatik 0 önek — "input'ta otomatik 0 ile başlat"
      var v = tel.value;
      if (/^[5]/.test(v.replace(/\s+/g, ''))) tel.value = '0' + v;
    });
    tel.addEventListener('blur', function () {
      if (tel.value === '0') tel.value = '';
    });
  }

  /* ------------------------------------------------- açık adres sayacı */

  /** maxlength'te tarayıcı sessizce durur; 240 karakterden sonra "257/300"
      gösterilir, sınırda uyarı rengine döner (21 Eyl 2026). */
  function bindAddressCounter() {
    var ta = getControl('acik_adres');
    var sayac = $('[data-ycod-sayac="acik_adres"]', M.root);
    if (!ta || !sayac) return;
    var max = parseInt(sayac.getAttribute('data-max'), 10) || ADRES_MAX;
    function guncelle() {
      var n = (ta.value || '').length;
      if (n < ADRES_SAYAC_ESIK) {
        sayac.hidden = true;
        sayac.classList.remove('is-limit');
        return;
      }
      sayac.hidden = false;
      sayac.textContent = n + '/' + max + (n >= max ? ' — sınıra ulaştın, kısaltabilirsin' : '');
      sayac.classList.toggle('is-limit', n >= max);
    }
    ta.addEventListener('input', guncelle);
    guncelle();
  }

  /* --------------------------------------------------------- doğrulama */

  function setFieldError(name, msg) {
    var err = $('[data-ycod-err="' + name + '"]', M.root);
    var control = getControl(name);
    if (err) {
      err.textContent = msg || '';
      err.hidden = !msg;
    }
    if (control) {
      control.classList.toggle('is-invalid', !!msg);
      if (msg) control.setAttribute('aria-invalid', 'true');
      else control.removeAttribute('aria-invalid');
    }
  }

  function validate() {
    var values = {};
    var firstBad = null;

    function bad(name, msg) {
      setFieldError(name, msg);
      if (!firstBad) firstBad = getControl(name);
    }

    var ad = (getControl('ad_soyad') || {}).value || '';
    ad = ad.trim().replace(/\s+/g, ' ');
    if (ad.length < 5 || ad.indexOf(' ') === -1 || ad.length > 80) {
      bad('ad_soyad', 'Adını ve soyadını birlikte yaz.');
    } else {
      setFieldError('ad_soyad', '');
      values.ad_soyad = ad;
    }

    var telRaw = (getControl('telefon') || {}).value || '';
    var tel = normalizePhone(telRaw);
    if (!tel) {
      bad('telefon', 'Cep numaranı 05XX XXX XX XX biçiminde yaz (başında fazladan 0 ya da +90 varsa sil).');
    } else {
      setFieldError('telefon', '');
      values.telefon = tel;
    }

    var il = ((getControl('il') || {}).value || '').trim();
    if (!il) {
      bad('il', 'İlini seç.');
    } else {
      setFieldError('il', '');
      values.il = il;
    }

    var ilce = ((getControl('ilce') || {}).value || '').trim();
    if (!ilce) {
      bad('ilce', M.manualAddress ? 'İlçeni yaz.' : 'İlçeni seç.');
    } else {
      setFieldError('ilce', '');
      values.ilce = ilce;
    }

    var mahalle = '';
    var mahalleDiger = '';
    if (M.manualAddress) {
      // Liste alınamadıysa mahalle de serbest metinden gelir
      mahalle = MAHALLE_DIGER;
      setFieldError('mahalle', '');     // liste modundan kalan uyarı görünmesin
      mahalleDiger = ((getControl('mahalle_diger') || {}).value || '').trim();
      if (mahalleDiger.length < 3) {
        bad('mahalle_diger', 'Mahalle ya da köy adını yaz.');
      } else {
        setFieldError('mahalle_diger', '');
      }
    } else {
      mahalle = ((getControl('mahalle') || {}).value || '').trim();
      if (!mahalle) {
        bad('mahalle', 'Mahalleni listeden seç.');
      } else {
        setFieldError('mahalle', '');
      }
      if (mahalle === MAHALLE_DIGER) {
        mahalleDiger = ((getControl('mahalle_diger') || {}).value || '').trim();
        if (mahalleDiger.length < 3) {
          bad('mahalle_diger', 'Köyünün ya da mahallenin adını yaz.');
        } else {
          setFieldError('mahalle_diger', '');
        }
      }
    }
    values.mahalle = mahalle;
    values.mahalle_diger = mahalleDiger;

    var adres = ((getControl('acik_adres') || {}).value || '').trim().replace(/\s+/g, ' ');
    if (adres.length < ADRES_MIN) {
      bad('acik_adres', 'Adresini biraz daha ayrıntılı yaz (sokak, bina ve daire no).');
    } else if (adres.length > ADRES_MAX) {
      // maxlength normalde buraya düşürmez; yapıştırma/eski tarayıcı için yedek.
      bad('acik_adres', 'Açık adres en fazla ' + ADRES_MAX + ' karakter olabilir (şu an ' + adres.length + '). Biraz kısaltıp tekrar dene.');
    } else {
      setFieldError('acik_adres', '');
      values.acik_adres = adres;
    }

    var eposta = ((getControl('eposta') || {}).value || '').trim();
    if (eposta && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(eposta) || eposta.length > 254)) {
      bad('eposta', 'E-posta adresi geçerli görünmüyor.');
    } else {
      setFieldError('eposta', '');
      values.eposta = eposta;
    }

    if (firstBad) {
      if (firstBad.focus) firstBad.focus();
      return null;
    }
    return values;
  }

  /* ------------------------------------------------------------- kaynak */

  function buildKaynak() {
    var src = {};
    try {
      src = JSON.parse(sessionStorage.getItem('yigitfy_kaynak')) || {};
    } catch (e) {
      src = {};
    }
    var fbclid = src.fbclid || '';
    if (!fbclid) {
      try {
        fbclid = new URLSearchParams(window.location.search).get('fbclid') || '';
      } catch (e) {}
    }
    // Takip verisi sipariş DÜŞÜRMEZ: uzun reklam URL'leri (fbclid + Türkçe UTM)
    // 500'ü aşıp panelde 422'ye düşüyordu (14-21 Eyl 2026, 45 müşteri). Panel
    // artık kırpıyor; burada da kırpılır ki hiçbir sürüm eşleşmesinde tekrarlamasın.
    function kes(v, n) { return String(v == null ? '' : v).slice(0, n); }
    return {
      url: kes(window.location.href, 500),
      referrer: kes(document.referrer || '', 500),
      utm_source: kes(src.utm_source || '', 200),
      utm_medium: kes(src.utm_medium || '', 200),
      utm_campaign: kes(src.utm_campaign || '', 200),
      utm_content: kes(src.utm_content || '', 200),
      utm_term: kes(src.utm_term || '', 200),
      fbclid: kes(fbclid, 500),
      fbp: kes(readCookie('_fbp'), 200),
      fbc: kes(readCookie('_fbc'), 500),
      event_id: kes(M.eventId, 64)
    };
  }

  /* ------------------------------------------------------------ uyarılar */

  function hideAlerts() {
    if (M.alert) M.alert.hidden = true;
    if (M.wa) M.wa.hidden = true;
  }

  function showAlert(msg) {
    cOlay('kapida_hata_gosterildi');
    if (!M.alert) return;
    M.alert.textContent = msg;
    M.alert.hidden = false;
    M.alert.scrollIntoView({ block: 'nearest' });
  }

  function showWaFallback() {
    showAlert('Sipariş alınamadı. Bağlantını kontrol edip tekrar dene.');
    if (M.wa) M.wa.hidden = false;
  }

  /* --------------------------------------------------- kalemler (ortak) */

  /** Panele gidecek kalemleri toplar — sipariş gövdesi VE indirim kodu ön
      izlemesi AYNI listeyi kullanır (iki kopya olsaydı indirim başka sepete
      biçilirdi). Dönüş: {kalemler, kademe, bump, bump2, bump2_variant} ya da
      {hata: 'müşteriye gösterilecek metin'}. */
  function kalemleriTopla() {
    var tier = M.tiers[M.tierIdx] || M.tiers[0];
    var kalemler, kademe, withBump, withBump2;
    if (M.mode === 'cart') {
      var lines = M.cart || [];
      if (!lines.length) return { hata: 'Sepetin boş. Önce bir ürün ekle.' };
      // Panel sınırları (app/kapida.py MAX_KALEM=30, MAX_ADET=10) — iki taraf
      // AYNI sayıyı taşır. 21 Eyl 2026: 8 farklı ürün sınırına müşteri takıldı → 30.
      if (lines.length > MAX_KALEM) {
        return { hata: 'Kapıda ödeme için sepette en fazla ' + MAX_KALEM + ' farklı ürün olabilir (sepette ' +
          lines.length + ' var). Fazlasını ayrı bir siparişle ya da WhatsApp\'tan verebilirsin.' };
      }
      var fazla = lines.filter(function (l) { return l.qty > MAX_ADET; })[0];
      if (fazla) {
        return { hata: 'Bir üründen kapıda ödemeyle en fazla ' + MAX_ADET + ' adet alınabilir (' +
          (fazla.product_title || fazla.title || 'bir ürün') + ': ' + fazla.qty + ' adet). Adedi düşürüp tekrar dene; daha fazlası için WhatsApp\'tan yazabilirsin.' };
      }
      kalemler = lines.map(function (l) {
        return { variant_id: String(l.variant_id), adet: l.qty };
      });
      // Panelin PDP ek ürün korumaları bump bayrağıyla çalışır: yuva a ürünü
      // (10'lu Karides) sepette tek adetse ve yanında başka ürün varsa bayrak
      // açık (upsell-bump etiketi).
      var ekUrun = lines.filter(function (l) { return String(l.variant_id) === String(M.cfg.bumpVariant); })[0];
      withBump = !!(M.cfg.bumpVariant && ekUrun && ekUrun.qty === 1 && lines.length > 1);
      var firsatSepet = firsatSecili().filter(function (f) { return !cartHasVariant(f.variant); });
      withBump2 = firsatSepet.length > 0;
      firsatSepet.forEach(function (f) { kalemler.push({ variant_id: String(f.variant), adet: 1 }); });
      kademe = Math.min(3, lines.reduce(function (m, l) { return Math.max(m, l.qty); }, 1));
    } else {
      // variant_id METİN olarak gönderilir: panel sözleşmesi string bekler
      // (sayı gönderildiğinde 422 "geçerli bir metin olmalı" hatası dönüyordu).
      kalemler = [{ variant_id: String(M.cfg.variantId), adet: tier.qty || 1 }];
      withBump = bumpChecked();
      if (withBump) kalemler.push({ variant_id: String(M.cfg.bumpVariant), adet: 1 });
      // İkinci ek ürün (b): bayraksız sıradan kalem; panel fiyatı ürünün
      // paket_fiyat metafield'ından (ana ürün varsa fırsat, yoksa katalog) biçer.
      if (bumpBChecked()) kalemler.push({ variant_id: String(M.cfg.bumpBVariant), adet: 1 });
      var firsatUrun = firsatSecili();
      withBump2 = firsatUrun.length > 0;
      firsatUrun.forEach(function (f) { kalemler.push({ variant_id: String(f.variant), adet: 1 }); });
      kademe = tier.qty || 1;
    }
    return {
      kalemler: kalemler,
      kademe: kademe,
      bump: withBump,
      bump2: withBump2,
      // Birden çok fırsat ürünü virgülle; panel (kapida.dogrula) listeyi ayırır
      bump2_variant: withBump2
        ? firsatSecili().map(function (f) { return String(f.variant); }).join(',')
        : '',
      // Kademe hediyesi: yalnız varyant bildirilir; panel hakkı adetlerden
      // yeniden biçer ve satırı 0 TL ekler (hak yoksa yok sayar)
      hediye_variant: hediyeHakki() ? String(M.cfg.hediyeVariant) : ''
    };
  }

  /* ------------------------------------------------------ indirim kodu
     "İndirim kodum var" (10 Eyl 2026). Akış: müşteri kodu yazar → Uygula →
     panel /kod ucu kodu Shopify'dan okuyup indirimi bu sepete göre kuruş
     olarak biçer → yeşil şerit + toplamda "İndirim (KOD) −tutar". Kademe, ek
     ürün ya da sepet değişirse kod SESSİZCE yeniden doğrulanır (indirim
     satırlara bağlı; ürün indirimiyle birleşmeyen kod indirimli satırlara
     uygulanmaz). Siparişte panel kodu yeniden doğrular; kod_hatasi dönerse
     kod düşürülür, mesaj alanın altında gösterilir. */

  /** Kodun bağlı olduğu sepet imzası: değişince yeniden doğrulanır. */
  function kodImza() {
    var b = kalemleriTopla();
    if (b.hata) return '';
    return JSON.stringify([M.mode, b.kalemler, b.bump, b.bump2, b.bump2_variant]);
  }

  function kodAcKapat(ac) {
    if (!M || !M.kodPanel) return;
    if (typeof ac !== 'boolean') ac = !M.kodAcik;
    M.kodAcik = ac;
    M.kodPanel.classList.toggle('is-open', ac);
    if (M.kodToggle) M.kodToggle.setAttribute('aria-expanded', ac ? 'true' : 'false');
  }

  function kodYukleniyor(ac) {
    if (M.kodBtn) M.kodBtn.setAttribute('aria-busy', ac ? 'true' : 'false');
    if (M.kodInput) M.kodInput.readOnly = !!ac;
  }

  /** Durumu ekrana yansıtır: giriş satırı ↔ uygulanmış kod şeridi + toplam satırı. */
  function kodGoster() {
    if (!M || !M.kodPanel) return;
    var uygulandi = !!M.kod;
    goster(M.kodRow, !uygulandi);
    goster(M.kodOk, uygulandi);
    goster(M.kodSatir, uygulandi && M.kod.indirim > 0);
    if (uygulandi) {
      if (M.kodOkAd) M.kodOkAd.textContent = M.kod.kod;
      if (M.kodOkAciklama) M.kodOkAciklama.textContent = M.kod.aciklama ? '· ' + M.kod.aciklama : '';
      if (M.kodSatirAd) M.kodSatirAd.textContent = M.kod.kod;
      if (M.kodSatirTutar) M.kodSatirTutar.textContent = '−' + money(M.kod.indirim);
      if (M.kodInput) M.kodInput.value = M.kod.kod;
      kodAcKapat(true);
    }
    if (M.kodToggleText) {
      M.kodToggleText.textContent = uygulandi ? 'İndirim kodu uygulandı' : 'İndirim kodum var';
    }
  }

  /** Yazılmış ama henüz uygulanmamış kod var mı? (SİPARİŞİ TAMAMLA önce uygular) */
  function kodBekliyor() {
    return !!(M.kodInput && M.kodInput.value.replace(/\s+/g, '') && !M.kod);
  }

  /** Kodu panelde doğrular. sessiz=true: sepet değişince kendiliğinden
      (Clarity olayı yok). cb(ok) isteğe bağlı. */
  function kodUygula(kod, sessiz, cb) {
    if (!M || !M.kodInput) return;
    kod = String(kod || '').replace(/\s+/g, '').toUpperCase();
    if (!kod) {
      setFieldError('indirim_kodu', 'İndirim kodunu yaz.');
      if (cb) cb(false);
      return;
    }
    var sepet = kalemleriTopla();
    if (sepet.hata) {
      setFieldError('indirim_kodu', sepet.hata);
      if (cb) cb(false);
      return;
    }
    var tel = normalizePhone((getControl('telefon') || {}).value || '');
    var payload = {
      kod: kod,
      kalemler: sepet.kalemler,
      kademe: sepet.kademe,
      bump: sepet.bump,
      bump2: sepet.bump2,
      bump2_variant: sepet.bump2_variant,
      hediye_variant: sepet.hediye_variant,
      // Telefon/e-posta yazılmışsa "müşteri başına bir kez" denetimi şimdiden
      telefon: tel || '',
      eposta: ((getControl('eposta') || {}).value || '').trim()
    };
    var sira = ++M.kodIstek;
    var imza = kodImza();
    kodYukleniyor(true);
    if (!sessiz) cOlay('kapida_kod_denendi');

    // Geçici hata (ağ, zaman aşımı, 429, 5xx): SESSİZ yenilemede uygulanmış kod
    // KORUNUR (panel sipariş anında zaten yeniden doğrular); müşteri "Uygula"ya
    // bastıysa mesaj gösterilir ama alan kilitli kalmaz. 21 Eyl 2026.
    function geciciHata(msg) {
      if (sessiz && M.kod) {
        M.kod.imza = imza;                    // aynı sepet için yeniden sorma
        if (cb) cb(true);
        return;
      }
      kodDus(msg);
      if (cb) cb(false);
    }

    fetchZamanAsimli(M.cfg.endpoint + '/api/kapida/' + encodeURIComponent(M.cfg.storeId) + '/kod', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Yigitfy-Form-Key': M.cfg.formKey
      },
      body: JSON.stringify(payload)
    }, 10000)
      .then(function (r) {
        return r.json().catch(function () { return null; }).then(function (body) {
          return { res: r, body: body };
        });
      })
      .then(function (out) {
        if (!M) return;
        if (sira !== M.kodIstek) {              // daha yeni bir istek var / kod kaldırıldı
          if (sira === M.kodSonBiten) kodYukleniyor(false);
          return;
        }
        M.kodSonBiten = sira;
        kodYukleniyor(false);
        if (out.res.ok && out.body && out.body.ok) {
          M.kod = {
            kod: out.body.kod || kod,
            indirim: parseInt(out.body.indirim_kurus, 10) || 0,
            aciklama: out.body.aciklama || '',
            imza: imza
          };
          setFieldError('indirim_kodu', '');
          kodGoster();
          updateTotals();
          if (!sessiz) cOlay('kapida_kod_uygulandi');
          if (cb) cb(true);
          return;
        }
        if (out.res.status === 429 || out.res.status >= 500 || !out.body) {
          geciciHata('Kod şu an doğrulanamadı; biraz sonra tekrar dene. Kodsuz devam etmek için alanı boşalt.');
          return;
        }
        kodDus((out.body && out.body.error) || 'Kod şu an doğrulanamadı; biraz sonra tekrar dene.');
        cOlay('kapida_kod_hatasi');
        if (cb) cb(false);
      })
      .catch(function () {
        if (!M || sira !== M.kodIstek) return;
        kodYukleniyor(false);
        geciciHata('Kod şu an doğrulanamadı. Bağlantını kontrol edip tekrar dene; kodsuz devam etmek için alanı boşalt.');
      });
  }

  /** Kodu düşürür, mesajı alanın altında gösterir; yazılan kod alanda kalır
      (müşteri hangi kodun reddedildiğini görsün, düzeltebilsin). */
  function kodDus(msg) {
    M.kod = null;
    kodGoster();
    kodAcKapat(true);
    setFieldError('indirim_kodu', msg);
    updateTotals();
  }

  function kodKaldir() {
    if (!M) return;
    M.kodIstek++;             // uçuştaki doğrulama yanıtı yok sayılsın
    clearTimeout(M.kodZamanlayici);
    kodYukleniyor(false);     // uçuştaki istek alanı salt-okunur bırakmasın
    M.kod = null;
    if (M.kodInput) M.kodInput.value = '';
    setFieldError('indirim_kodu', '');
    kodGoster();
    updateTotals();
    cOlay('kapida_kod_kaldirildi');
    if (M.kodInput) M.kodInput.focus({ preventScroll: true });
  }

  /** Sepet/kademe/ek ürün değişince uygulanmış kod sessizce yeniden doğrulanır. */
  function kodTazele() {
    if (!M || !M.kod) return;
    if (M.mode === 'cart' && !M.cart) return;   // sepet daha gelmedi
    var imza = kodImza();
    if (!imza || imza === M.kod.imza) return;
    clearTimeout(M.kodZamanlayici);
    var kod = M.kod.kod;
    M.kodZamanlayici = setTimeout(function () {
      if (M && M.kod && M.kod.kod === kod && kodImza() !== M.kod.imza) kodUygula(kod, true);
    }, 350);
  }

  /* ------------------------------------------------------------- gönderim */

  function onSubmit(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (!M) return;
    if (M.submitting) {
      // 21 Eyl 2026: eskiden sessizce yutuluyordu; müşteri "basıyorum olmuyor" sanıyordu.
      showAlert('Siparişin gönderiliyor, lütfen birkaç saniye bekle.');
      return;
    }
    hideAlerts();

    // Honeypot doluysa hiç gönderme (spec §5.2/8) — sessiz çıkış.
    if (M.hp && M.hp.value) return;

    var tms = Date.now() - M.openedAt;
    if (tms < MIN_SUBMIT_MS) {
      // Çok hızlı (otomatik doldurma): engelleyip yanlış mesaj vermek yerine
      // kalan süreyi bekleyip kendiliğinden gönder (panel 3 sn eşiğini uyguluyor).
      if (M.submitBtn) M.submitBtn.classList.add('is-loading');
      clearTimeout(M.hizliZamanlayici);
      M.hizliZamanlayici = setTimeout(function () {
        if (M && M.submitBtn) M.submitBtn.classList.remove('is-loading');
        if (M) onSubmit(null);
      }, MIN_SUBMIT_MS - tms + 50);
      return;
    }

    cOlay('kapida_gonder_denendi');
    var values = validate();
    if (!values) {
      cOlay('kapida_dogrulama_hatasi');
      return;
    }

    var sepet = kalemleriTopla();
    if (sepet.hata) {
      showAlert(sepet.hata);
      return;
    }

    // Kod yazılmış ama Uygula'ya basılmamışsa önce uygulanır, sonra gönderilir
    // (müşteri kodu yazıp doğrudan SİPARİŞİ TAMAMLA'ya basabiliyor). Kod
    // reddedilirse sipariş GÖNDERİLMEZ: mesaj alanın altında, müşteri karar verir.
    if (kodBekliyor()) {
      kodUygula(M.kodInput.value, false, function (ok) {
        if (ok) onSubmit(e);
        else showAlert('Sipariş gönderilmedi: indirim kodu kabul edilmedi. Kodu düzelt ya da alanı boşaltıp tekrar dene.');
      });
      return;
    }

    var payload = {
      idempotency_key: M.idKey,
      musteri: {
        ad_soyad: values.ad_soyad,
        telefon: values.telefon,
        eposta: values.eposta || ''
      },
      adres: {
        il: values.il,
        ilce: values.ilce,
        mahalle: values.mahalle,
        mahalle_diger: values.mahalle_diger,
        acik_adres: values.acik_adres
      },
      kalemler: sepet.kalemler,
      kademe: sepet.kademe,
      bump: sepet.bump,
      bump2: sepet.bump2,
      bump2_variant: sepet.bump2_variant,
      hediye_variant: sepet.hediye_variant,
      // Uygulanmış indirim kodu; panel sipariş anında yeniden doğrular
      indirim_kodu: M.kod ? M.kod.kod : '',
      // Modalda basılan toplam (kuruş): panel hesabı bunu 1 TL'den fazla aşarsa
      // sipariş AÇILMAZ (kapıda ekranda görülenden fazla istenmesin). Yalnız
      // ret için; panel fiyatı asla bu sayıya göre düşürmez.
      gosterilen_kurus: gosterilenToplam(),
      kaynak: buildKaynak(),
      captcha: getCaptchaToken(),
      hp: '',
      t_ms: tms
    };

    M.submitting = true;
    if (M.submitBtn) {
      M.submitBtn.classList.add('is-loading');
      M.submitBtn.setAttribute('aria-disabled', 'true');
    }

    gonder(payload, 0);
  }

  /** Sipariş isteği. 21 Eyl 2026: 30 sn zaman aşımı (buton sonsuza dek dönmesin),
      panel 409 bekle:true derse (aynı anahtarla önceki deneme hâlâ uçuşta) 3 sn
      sonra AYNI gövde yeniden gönderilir — idempotency anahtarı sayesinde ikinci
      sipariş açılmaz. 429/5xx/JSON olmayan yanıtta WhatsApp yolu da gösterilir. */
  var GONDER_ZAMAN_ASIMI_MS = 30000;
  var BEKLE_TEKRAR_MAX = 4;

  function gonder(payload, deneme) {
    var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
    var zamanlayici = ctrl ? setTimeout(function () { ctrl.abort(); }, GONDER_ZAMAN_ASIMI_MS) : null;
    fetch(M.cfg.endpoint + '/api/kapida/' + encodeURIComponent(M.cfg.storeId) + '/siparis', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Yigitfy-Form-Key': M.cfg.formKey
      },
      body: JSON.stringify(payload),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) {
        return r
          .json()
          .catch(function () {
            return null;
          })
          .then(function (body) {
            return { res: r, body: body };
          });
      })
      .then(function (out) {
        if (zamanlayici) clearTimeout(zamanlayici);
        if (!M) return;
        if (out.res.ok && out.body && out.body.ok) {
          doneSubmitting();
          onSuccess(out.body, payload);
          return;
        }
        if (out.body && out.body.bekle && deneme < BEKLE_TEKRAR_MAX) {
          // Önceki deneme hâlâ işleniyor: buton dönmeye devam eder, 3 sn sonra yinele.
          showAlert(out.body.error || 'Siparişin işleniyor, lütfen bekle…');
          setTimeout(function () { if (M) gonder(payload, deneme + 1); }, 3000);
          return;
        }
        doneSubmitting();
        var msg = (out.body && (out.body.error || out.body.mesaj)) || '';
        if (out.body && out.body.bekle) {
          // Yineleme hakkı bitti, panel hâlâ "uçuşta" diyor: müşteri elle yinelesin.
          showAlert('Siparişin hâlâ işleniyor. 15 saniye sonra SİPARİŞİ TAMAMLA\'ya tekrar bas; aynı sipariş ikinci kez oluşmaz.');
          if (M.wa) M.wa.hidden = false;
          resetCaptcha();
          return;
        }
        if (out.body && out.body.kod_hatasi) {
          // Kod sipariş anında reddedildi (tükenmiş/süresi dolmuş…): kod düşer,
          // toplam eski hâline döner, mesaj kod alanının altında + üst bantta.
          kodDus(msg || 'İndirim kodu geçersiz.');
          cOlay('kapida_kod_hatasi');
          showAlert('Sipariş oluşturulmadı — ' + (msg || 'indirim kodu geçersiz.') +
            ' Kodu düzeltip ya da kaldırıp tekrar dene.');
        } else if (msg) {
          showAlert(msg);
          // Sunucu/limit hatalarında mesaj "WhatsApp'tan yaz" diyor; kutu da açılsın.
          if (out.res.status === 429 || out.res.status >= 500) { if (M.wa) M.wa.hidden = false; }
        } else if (out.res.status >= 500 || out.res.status === 429) {
          showAlert('Sunucuya şu an ulaşılamıyor (hata ' + out.res.status + '). Bir dakika sonra tekrar dene ya da WhatsApp\'tan sipariş ver.');
          if (M.wa) M.wa.hidden = false;
        } else {
          showWaFallback();
        }
        resetCaptcha();
      })
      .catch(function (err) {
        if (zamanlayici) clearTimeout(zamanlayici);
        if (!M) return;
        doneSubmitting();
        if (err && err.name === 'AbortError') {
          showAlert('Sunucudan yanıt alınamadı. Siparişin alınmış olabilir; tekrar denediğinde aynı sipariş ikinci kez oluşmaz.');
          if (M.wa) M.wa.hidden = false;
        } else {
          showWaFallback();
        }
        resetCaptcha();
      });
  }

  function doneSubmitting() {
    M.submitting = false;
    if (M.submitBtn) {
      M.submitBtn.classList.remove('is-loading');
      M.submitBtn.removeAttribute('aria-disabled');
    }
  }

  /* ---------------------------------------------------- başarı + piksel
     3 Eyl 2026: onay artık AYRI SAYFADA (sections/siparis-alindi.liquid,
     Tema ayarı cod_success_url, varsayılan /pages/siparis-alindi). Modal
     kaydı sessionStorage'a yazıp yönlendirir; sipariş no + piksel verisi
     URL'de de taşınır (sessionStorage kapalıysa bile sayfa dolsun). Pikseller
     o sayfada event_id başına tek kez atılır. Ayar boşsa eski modal içi onay
     ve modal içi piksel (yedek yol) aynen çalışır. */

  var OK_KEY = 'yigitfy_siparis_ok';      // sessionStorage: son başarılı siparişin kaydı
  var PX_KEY = 'yigitfy_px_atesli_v2';    // sessionStorage: pikseli atılmış event_id LİSTESİ
  var PX_LIMIT = 10;                      // aynı sekmedeki son N sipariş hatırlanır

  function ssGet(k) {
    try { return window.sessionStorage.getItem(k); } catch (e) { return null; }
  }
  function ssSet(k, v) {
    try { window.sessionStorage.setItem(k, v); return true; } catch (e) { return false; }
  }
  function readQuery() {
    var q = {};
    try {
      String(window.location.search || '').replace(/^\?/, '').split('&').forEach(function (p) {
        if (!p) return;
        // Her parametre kendi try'ında: bozuk bir %-dizisi (ör. utm'de %E0)
        // sonraki parametreleri düşürmesin.
        try {
          var i = p.indexOf('=');
          var k = decodeURIComponent(i < 0 ? p : p.slice(0, i));
          var v = i < 0 ? '' : decodeURIComponent(p.slice(i + 1).replace(/\+/g, ' '));
          q[k] = v;
        } catch (e2) {}
      });
    } catch (e) {}
    return q;
  }

  /** Başarı kaydı: sipariş alındı sayfasının ihtiyacı olan her şey (PII yok). */
  function basariKaydi(totalCents, payload, resp) {
    return {
      no: String(resp.siparis_no || '').slice(0, 24),
      t: Math.round(totalCents),
      e: String((payload.kaynak && payload.kaynak.event_id) || M.eventId || ''),
      i: payload.kalemler.map(function (k) { return String(k.variant_id); }),
      n: payload.kalemler.reduce(function (a, k) { return a + (k.adet || 0); }, 0),
      ts: Date.now()
    };
  }

  /** Sipariş alındı sayfası adresi; ayar boşsa/geçersizse '' (yedek yol).
      Yalnız site içi yol ("/…") ya da https adresi kabul edilir. Tema
      önizlemesindeki preview_theme_id korunur. */
  function basariSayfasi(kayit) {
    // Tarayıcı adresteki sekme/satır sonu/boşluğu YOK SAYIYOR: "/<TAB>/evil.com"
    // fiilen "//evil.com" (dış site) demek. Doğrulamadan ÖNCE temizlenir.
    var url = String(M.cfg.successUrl || '').replace(/[\s\u0000-\u001F]/g, '');
    if (!url) return '';
    if (!/^\/[^\/\\]/.test(url) && !/^https:\/\//i.test(url)) return '';
    var p = [];
    if (kayit.no) p.push('no=' + encodeURIComponent(kayit.no));
    if (kayit.e) p.push('e=' + encodeURIComponent(kayit.e));
    p.push('t=' + kayit.t);
    if (kayit.i.length) p.push('i=' + encodeURIComponent(kayit.i.join(',')));
    p.push('n=' + kayit.n);
    var q = readQuery();
    if (q.preview_theme_id) p.push('preview_theme_id=' + encodeURIComponent(q.preview_theme_id));
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + p.join('&');
  }

  /** Modal içi onay ekranı: sayfa yolu kapalıyken (yedek yol) ve yönlendirme
      hiç gerçekleşmediğinde kullanılır — sipariş oluştuysa müşteri MUTLAKA
      bir onay görmeli. */
  function modalOnayGoster(siparisNo, totalCents) {
    if (!M) return;
    if (M.form) M.form.hidden = true;
    if (M.success) {
      var noEl = $('[data-ycod-order-no]', M.success);
      if (noEl) noEl.textContent = siparisNo ? 'Sipariş No: ' + siparisNo : '';
      var payEl = $('[data-ycod-pay-line]', M.success);
      if (payEl) payEl.textContent = 'Kapıda ' + money(totalCents) + ' ödeyeceksin — kart veya nakit.';
      M.success.hidden = false;
      M.success.focus();
    }
  }

  function onSuccess(resp, payload) {
    M.succeeded = true;
    cOlay('kapida_siparis_tamamlandi');
    cEtiket('siparis_no', resp.siparis_no || '');
    var totalCents = parseInt(resp.toplam_kurus, 10);
    if (!totalCents || totalCents < 0) totalCents = grandTotal();

    var kayit = basariKaydi(totalCents, payload, resp);
    var hedef = basariSayfasi(kayit);
    if (hedef) {
      if (!ssSet(OK_KEY, JSON.stringify(kayit))) {
        // sessionStorage kapalı (iOS "tüm çerezleri engelle", uygulama içi
        // tarayıcılar): onay sayfasında tekrar kilidi işlemez. O yüzden piksel
        // BURADA atılır ve URL'ye piksel verisi (e/i/n) konmaz — sayfa
        // yenilense ya da adres paylaşılsa bile Purchase tekrarlanmaz.
        pikselAtes({
          metaPixel: M.cfg.metaPixel,
          tiktokPixel: M.cfg.tiktokPixel,
          t: totalCents, i: kayit.i, n: kayit.n, e: kayit.e, no: kayit.no
        });
        hedef = basariSayfasi({ no: kayit.no, t: kayit.t, e: '', i: [], n: 0 });
      }
      M.yonlendiriliyor = true;
      M.submitting = true;   // çift tıklama kilidi: yönlendirme bitene kadar
      if (M.submitBtn) {
        M.submitBtn.classList.add('is-loading');
        M.submitBtn.setAttribute('aria-disabled', 'true');
      }
      if (M.submitLabel) M.submitLabel.textContent = 'SİPARİŞİNİZ ALINDI';
      var git = function () { window.location.assign(hedef); };
      // Sepet modunda önce sepet boşaltılır (çift sipariş olmasın); yönlendirme
      // yarım isteği kesmesin diye beklenir, en geç 1,5 sn.
      var bekle = M.mode === 'cart' ? sepetiBosalt() : Promise.resolve();
      var sure = new Promise(function (r) { setTimeout(r, 1500); });
      Promise.race([bekle, sure]).then(git, git);

      // EMNİYET: yönlendirme 8 sn içinde gerçekleşmediyse (çevrimdışı, engellenmiş
      // gezinti) müşteri spinner'da kalmasın — modal içi onay gösterilir ve
      // piksel burada atılır (hedef sayfa hiç açılmayacağı için).
      setTimeout(function () {
        if (!M || !M.yonlendiriliyor) return;
        M.yonlendiriliyor = false;
        doneSubmitting();
        modalOnayGoster(kayit.no, totalCents);
        if (kayit.e && !pxAtildiMi(kayit.e)) {
          pxIsaretle(kayit.e);
          pikselAtes({
            metaPixel: M.cfg.metaPixel,
            tiktokPixel: M.cfg.tiktokPixel,
            t: totalCents, i: kayit.i, n: kayit.n, e: kayit.e, no: kayit.no
          });
        }
      }, 8000);
      return;
    }

    // YEDEK YOL: sayfa tanımlı değilse modal içi onay ekranı (eski davranış)
    modalOnayGoster(kayit.no, totalCents);

    pikselAtes({
      metaPixel: M.cfg.metaPixel,
      tiktokPixel: M.cfg.tiktokPixel,
      t: totalCents, i: kayit.i, n: kayit.n, e: kayit.e, no: kayit.no
    });
    if (M.mode === 'cart') sepetiBosalt();
  }

  /** §5.4 — pikseller YALNIZ başarı anında, lazy yüklenir. PageView tetiklenmez.
      veri: {metaPixel, tiktokPixel, t (kuruş), i (varyant id'leri), n (adet),
      e (event_id), no (sipariş no)} — modal yedek yolu ve sipariş alındı
      sayfası aynı fonksiyonu kullanır. */
  function pikselAtes(veri) {
    var valueTL = Math.round(veri.t) / 100;
    var ids = (veri.i || []).map(String);
    var numItems = veri.n || 0;

    // Meta Pixel — fbevents.js lazy init (PageView YOK), Purchase eventID'li (CAPI dedup)
    if (veri.metaPixel) {
      try {
        if (!window.fbq) {
          (function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
              n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = true;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = true;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
          })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        }
        window.fbq('init', veri.metaPixel);
        window.fbq(
          'track',
          'Purchase',
          {
            value: valueTL,
            currency: 'TRY',
            content_ids: ids,
            content_type: 'product',
            num_items: numItems
          },
          { eventID: veri.e }
        );
      } catch (e) {}
    }

    // TikTok Pixel — lazy load + CompletePayment (otomatik page görünümü çağrılmaz)
    if (veri.tiktokPixel) {
      try {
        if (!window.ttq) {
          (function (w, d, t) {
            w.TiktokAnalyticsObject = t;
            var ttq = (w[t] = w[t] || []);
            ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'];
            ttq.setAndDefer = function (obj, method) {
              obj[method] = function () {
                obj.push([method].concat(Array.prototype.slice.call(arguments, 0)));
              };
            };
            for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
            ttq.load = function (pixelId) {
              var url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
              ttq._i = ttq._i || {};
              ttq._i[pixelId] = [];
              ttq._i[pixelId]._u = url;
              ttq._t = ttq._t || {};
              ttq._t[pixelId] = +new Date();
              ttq._o = ttq._o || {};
              var s = d.createElement('script');
              s.type = 'text/javascript';
              s.async = true;
              s.src = url + '?sdkid=' + pixelId + '&lib=' + t;
              var f = d.getElementsByTagName('script')[0];
              f.parentNode.insertBefore(s, f);
            };
          })(window, document, 'ttq');
          window.ttq.load(veri.tiktokPixel);
        }
        window.ttq.track('CompletePayment', {
          value: valueTL,
          currency: 'TRY',
          content_id: ids[0] || ''
        });
      } catch (e) {}
    }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'yigitfy_cod_purchase',
        value: valueTL,
        order: veri.no || ''
      });
    } catch (e) {}
  }

  /* ------------------------------------------------ sipariş alındı sayfası
     sections/siparis-alindi.liquid ([data-ysa]). Sipariş no / tutar / piksel
     verisi URL'den (?no&e&t&i&n) ve sessionStorage kaydından okunur (URL
     öncelikli; kayıt başka bir siparişe aitse yok sayılır). WhatsApp
     bağlantısına sipariş numarası gömülür. Pikseller event_id başına tek kez
     atılır: sayfa yenilense de Purchase tekrarlanmaz. */

  function initSiparisAlindi() {
    var root = $('[data-ysa]');
    if (!root || root.getAttribute('data-ysa-hazir') === '1') return;
    root.setAttribute('data-ysa-hazir', '1');

    var q = readQuery();
    var kayit = null;
    try { kayit = JSON.parse(ssGet(OK_KEY) || 'null'); } catch (e) { kayit = null; }
    if (!kayit || typeof kayit !== 'object') kayit = {};
    if (q.e && kayit.e && kayit.e !== q.e) kayit = {};

    // Sipariş adı mağazaya göre değişebilir (ön ek/son ek): karakter listesiyle
    // kısıtlamak yerine yalnız kontrol/işaretleme karakterleri ayıklanır. Metin
    // textContent ile basılır, bağlantıya encodeURIComponent ile girer.
    var no = String(q.no || kayit.no || '').replace(/[\u0000-\u001F<>"']/g, '').trim().slice(0, 32);
    var toplam = parseInt(q.t || kayit.t, 10) || 0;
    if (!(toplam > 0 && toplam <= 100000000)) toplam = 0;   // saçma tutarda satır gizlenir
    var eventId = String(q.e || kayit.e || '').slice(0, 64);
    var ids = Array.isArray(kayit.i) && kayit.i.length ? kayit.i : (q.i ? String(q.i).split(',') : []);
    var adet = parseInt(q.n || kayit.n, 10) || 0;

    var noEl = $('[data-ysa-no]', root);
    var orderEl = $('[data-ysa-order]', root);
    if (no && noEl) {
      noEl.textContent = no;
      if (orderEl) orderEl.hidden = false;
    }
    var payEl = $('[data-ysa-pay]', root);
    var paySablon = root.getAttribute('data-pay-text') || '';
    if (payEl && toplam > 0 && paySablon) {
      payEl.textContent = paySablon.replace(/\{tutar\}/g, money(toplam));
      payEl.hidden = false;
    }
    // "Sipariş numaranız mesaja eklenir" notu, numara yokken doğru değil
    var notEl = $('[data-ysa-wa-note]', root);
    if (notEl && !no) notEl.hidden = true;

    // WhatsApp: numara tema ayarından, hazır mesaja sipariş numarası gömülü
    var wa = $('[data-ysa-wa]', root);
    var waNo = digitsOnly(root.getAttribute('data-wa-no'));
    if (wa && waNo) {
      var sablon = no ? root.getAttribute('data-wa-text') : root.getAttribute('data-wa-text-genel');
      var metin = String(sablon || '').replace(/\{no\}/g, no);
      if (metin) wa.href = 'https://wa.me/' + waNo + '?text=' + encodeURIComponent(metin);
    }

    // Piksel YALNIZ bu sekmenin kendi sipariş kaydıyla eşleşirse atılır: adres
    // biriyle paylaşılınca ya da elle uydurulunca sahte Purchase üretilemez.
    // (sessionStorage kapalıysa kayıt hiç yazılamaz — o durumda piksel zaten
    // modalda, sipariş yanıtı gelir gelmez atılmıştır.)
    if (eventId && toplam > 0 && kayit.e === eventId && !pxAtildiMi(eventId)) {
      pxIsaretle(eventId);
      pikselAtes({
        metaPixel: root.getAttribute('data-meta-pixel') || '',
        tiktokPixel: root.getAttribute('data-tiktok-pixel') || '',
        t: toplam, i: ids, n: adet, e: eventId, no: no
      });
    }
    // Piksel verisi adresten silinir (sipariş no + tutar kalır): yenileme,
    // geri/ileri ya da adresi biriyle paylaşma Purchase'ı ikinci kez atmasın.
    pikselParametreleriniSil();
  }

  /** Bu sekmede pikseli atılmış son PX_LIMIT event_id (tek slot yetmiyordu:
      iki sipariş sonrası geçmişte ilkine dönülünce Purchase tekrar atılıyordu). */
  function pxListesi() {
    try {
      var a = JSON.parse(ssGet(PX_KEY) || '[]');
      return Array.isArray(a) ? a : [];
    } catch (e) {
      return [];
    }
  }
  function pxAtildiMi(id) {
    return pxListesi().indexOf(id) >= 0;
  }
  function pxIsaretle(id) {
    var a = pxListesi();
    a.push(id);
    if (a.length > PX_LIMIT) a = a.slice(a.length - PX_LIMIT);
    ssSet(PX_KEY, JSON.stringify(a));
  }

  /** ?e (event_id), ?i ve ?n adresten düşürülür; no + t + diğerleri kalır.
      History API yoksa sessizce çıkar (kilit zaten sessionStorage'da). */
  function pikselParametreleriniSil() {
    try {
      if (!window.history || !window.history.replaceState) return;
      var q = readQuery();
      if (!q.e && !q.i && !q.n) return;
      var p = [];
      Object.keys(q).forEach(function (k) {
        if (k === 'e' || k === 'i' || k === 'n') return;
        p.push(encodeURIComponent(k) + '=' + encodeURIComponent(q[k]));
      });
      window.history.replaceState(
        null, '', window.location.pathname + (p.length ? '?' + p.join('&') : '') + window.location.hash
      );
    } catch (e) {}
  }

  /* ----------------------------------------------------------- turnstile */

  function loadTurnstile() {
    if (!M || !M.captchaEl || !M.cfg.sitekey || M.captchaLoaded) return;
    M.captchaLoaded = true;

    function renderWidget() {
      if (!window.turnstile || M.captchaWidget !== null) return;
      try {
        M.captchaWidget = window.turnstile.render(M.captchaEl, {
          sitekey: M.cfg.sitekey,
          // Kutu normalde görünmez; doğrulama arka planda döner. Cloudflare
          // ziyaretçiden şüphelenirse widget kendiliğinden görünür olur.
          appearance: 'interaction-only',
          callback: function (token) {
            M.captchaToken = token || '';
          },
          'expired-callback': function () {
            M.captchaToken = '';
          },
          'error-callback': function () {
            M.captchaToken = '';
          }
        });
      } catch (e) {}
    }

    if (window.turnstile) {
      renderWidget();
      return;
    }
    window.__ycodTurnstileReady = renderWidget;
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=__ycodTurnstileReady&render=explicit';
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
  }

  function getCaptchaToken() {
    if (!M.cfg.sitekey) return '';
    try {
      if (window.turnstile && M.captchaWidget !== null) {
        return window.turnstile.getResponse(M.captchaWidget) || M.captchaToken || '';
      }
    } catch (e) {}
    return M.captchaToken || '';
  }

  function resetCaptcha() {
    try {
      if (window.turnstile && M.captchaWidget !== null) window.turnstile.reset(M.captchaWidget);
    } catch (e) {}
    M.captchaToken = '';
  }

  /* ----------------------------------------------------- global dinleyiciler */

  /* ------------------------------------------- katalog kartından kapıda ödeme
     Koleksiyon/arama kartındaki "Kapıda Ödemeyle Sipariş" (data-kart-cod=
     <variant>): ürün sepette yoksa 1 adet ekler, çekmece sayacını tazeler
     (çekmeceyi AÇMAZ) ve sepet modlu formu açar — müşteri ürün sayfasına
     hiç inmeden sipariş verir. Sepetteki diğer ürünler de forma gelir (sepet
     modunun tasarımı). Bir şey ters giderse ürün sayfasına gider. */
  function kartCodAc(btn) {
    if (btn.classList.contains('is-loading')) return;
    var vid = parseInt(btn.getAttribute('data-kart-cod'), 10);
    if (!vid) return;
    var T = window.ArkhelaisTheme || {};
    btn.classList.add('is-loading');
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sepette = (cart.items || []).some(function (it) { return it.variant_id === vid; });
        if (sepette) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('sepete eklenemedi');
          return r.json();
        });
      })
      .then(function () {
        try {
          if (T.CartDrawer && typeof T.CartDrawer.refresh === 'function') T.CartDrawer.refresh();
        } catch (err) {}
        cOlay('kapida_kart_acildi');
        btn.classList.remove('is-loading');
        initModal();
        openModal('cart');
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        var url = btn.getAttribute('data-kart-url');
        if (url) window.location.href = url;
      });
  }

  function onDocClick(e) {
    // Sipariş alındı sayfasına gidiliyor: hiçbir tıklama akışı bozmasın
    if (M && M.yonlendiriliyor) return;
    var kartCod = e.target.closest('[data-kart-cod]');
    if (kartCod) {
      e.preventDefault();
      kartCodAc(kartCod);
      return;
    }
    var opener = e.target.closest('[data-cod-open]');
    if (opener) {
      e.preventDefault();
      var acilisModu = opener.getAttribute('data-cod-open') === 'cart' ? 'cart' : 'product';
      initModal();
      // Ürün modunda önce eldiven popup'ı (sayfada bir kez), sonra form
      if (acilisModu === 'product' && !(M && M.open) && popGerekli() && popAc()) return;
      openModal(acilisModu);
      return;
    }
    if (M && M.popAcik) {
      if (e.target.closest('[data-ycod-pop-evet]')) {
        e.preventDefault();
        popKapat('evet');
      } else if (e.target.closest('[data-ycod-pop-hayir]')) {
        e.preventDefault();
        popKapat('hayir');
      }
      return;
    }
    if (!M || !M.open) return;
    if (e.target.closest('[data-ycod-sepet-duzenle]')) {
      // Sepet modunda "Sepeti düzenle": modal kapanır, çekmece açılır
      // (sepet sayfasındaysak sayfa zaten sepet).
      e.preventDefault();
      closeModal();
      var T = window.ArkhelaisTheme || {};
      if (!onCartPage() && T.CartDrawer && typeof T.CartDrawer.open === 'function') {
        try { T.CartDrawer.open(); } catch (err) {}
      }
      return;
    }
    if (e.target.closest('[data-ycod-close]')) {
      e.preventDefault();
      closeModal();
    }
  }

  function onDocKeydown(e) {
    if (M && M.yonlendiriliyor) return;   // yönlendirme sırasında Esc yok sayılır
    if (M && M.popAcik) {
      if (e.key === 'Escape') popKapat('hayir');
      return;
    }
    if (!M || !M.open) return;
    if (e.key === 'Escape') {
      closeModal();
      return;
    }
    if (e.key !== 'Tab') return;
    // Focus trap: sekme modal içinde döner
    var focusables = $$(
      'a[href], button:not([disabled]), input:not([disabled]):not([hidden]), select:not([disabled]):not([hidden]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      M.panel
    ).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function init() {
    initModal();
    initSiparisAlindi();
  }

  document.addEventListener('click', onDocClick);
  document.addEventListener('keydown', onDocKeydown);

  // Geri tuşu: sipariş verilen sayfa bfcache'ten JS durumuyla geri gelir —
  // modal "SİPARİŞİNİZ ALINDI" kilidinde kalıyor, sepet sayacı bayat oluyordu.
  // Sipariş verilmiş bir sayfaya dönülüyorsa sayfa tazelenir; diğer durumda
  // yalnız gönderim kilidi açılır.
  window.addEventListener('pageshow', function (e) {
    if (!e || !e.persisted || !M) return;
    if (M.succeeded || M.yonlendiriliyor) {
      window.location.reload();
      return;
    }
    doneSubmitting();
  });
  ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      initModal();
      popGorselOnyukle();
    }, { once: true, passive: true });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor bölümü yeniden yüklerse elemanları tazele
  document.addEventListener('shopify:section:load', init);
})();
